import { render } from "./ClientContract.vue?vue&type=template&id=dec5d082"
import script from "./ClientContract.vue?vue&type=script&lang=js"
export * from "./ClientContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__